import { Swiper, Pagination, EffectFade, Mousewheel, Autoplay } from 'swiper';
Swiper.use( [Pagination, EffectFade, Mousewheel, Autoplay ] );

class StudentAnimation {
	constructor( block ) {

		// GO TO FULL SECTIONS
		function goToSection(i, anim) {
			gsap.to(window, {
				scrollTo: {y: i*innerHeight, autoKill: false},
				duration: 0.7,
			});

			if(anim) {
				anim.restart();
			}
		}

		gsap.utils.toArray(".panel").forEach((panel, i) => {
			ScrollTrigger.create({
				trigger: panel,
				start: "top bottom",
				onEnter: () => goToSection(i),
			});
			// ScrollTrigger.create({
			// 	trigger: panel,
			// 	start: "bottom bottom",
			// 	onEnterBack: () => goToSection(i),
			// });
		});

		// ScrollTrigger.create({
		// 	trigger: ".intro-slide",
		// 	start: "bottom 95%",
		// 	onEnterBack: () => goToSection(i),
		// });

		// var fauxSections = gsap.utils.toArray(".anim-active .faux-section");
		// var fauxSectionsCount = fauxSections.length;
		// var animationPanels = gsap.utils.toArray(".block-student-animation__panel");

		// function nextSlide(i, isActive) {

		// 	console.log("next");

		// 	var slideIndex = i + 2;

		// 	if (slideIndex > fauxSectionsCount) {
		// 		return;
		// 	} else {
		// 		var getSlide = document.querySelector("[data-panel='" + slideIndex +"']");
		// 		var messageContainer = document.querySelector(".block-student-animation__sub-title");
		// 		var messageContainerSpan = messageContainer.querySelector("span");
		// 		var getSlideMessage = getSlide.getAttribute("data-message");

		// 		gsap.to(window, {duration: 0.7, scrollTo:"[data-panel-index='" + slideIndex +"']"});
		// 		gsap.to(animationPanels[i + 1], {duration: 0.8, autoAlpha: 1});

		// 		gsap.to(messageContainer, {width:"0px", duration: 1});
		// 		gsap.to(messageContainerSpan, {autoAlpha:"0", duration: 0.5});

		// 		setTimeout(function(){
		// 			messageContainerSpan.textContent = getSlideMessage;
		// 		}, 300);

		// 		gsap.to(messageContainer, {width:"auto", duration: 1, delay: 0.5});
		// 		gsap.to(messageContainerSpan, {autoAlpha:"1", duration: 0.5, delay: 0.5});
		// 	}

		// }

		// function prevSlide(i) {

		// 	console.log("previous");

		// 	var slideIndex = i + 1;

		// 	var getSlide = document.querySelector("[data-panel='" + slideIndex +"']");
		// 	var messageContainer = document.querySelector(".block-student-animation__sub-title");
		// 	var messageContainerSpan = messageContainer.querySelector("span");

		// 	if (getSlide) {
		// 		var getSlideMessage = getSlide.getAttribute("data-message");
		// 	}

		// 	gsap.to(window, {duration: 0.7, scrollTo:"[data-panel-index='" + slideIndex +"']"});
		// 	gsap.to(animationPanels[i + 1], {duration: 0.8, autoAlpha: 0});

		// 	if (getSlide) {
		// 		gsap.to(messageContainer, {width:"0px", duration: 1});
		// 		gsap.to(messageContainerSpan, {autoAlpha:"0", duration: 0.5});

		// 		setTimeout(function(){
		// 			messageContainerSpan.textContent = getSlideMessage;
		// 		}, 300);

		// 		gsap.to(messageContainer, {width:"auto", duration: 1, delay: 0.5});
		// 		gsap.to(messageContainerSpan, {autoAlpha:"1", duration: 0.5, delay: 0.5});
		// 	}
		// }


		// fauxSections.forEach((faux, i) => {

		// 	ScrollTrigger.create({
		// 		trigger: faux,
		// 		start: "bottom 95%",
		// 		id: "student-" + i,
		// 		endTrigger: ".block-scrolling-text",
		// 		end: "top bottom",
		// 		// scrub: true,
		// 		onEnter: ({progress, isActive}) => nextSlide(i),
		// 		onEnterBack: () => prevSlide(i),
		// 		// markers: true,
		// 		// onUpdate: self => {
		// 		// 	if(self.progress > 0 && self.progress < 1) {
		// 		// 	  inAction = true;
		// 		// 	} else {
		// 		// 	  inAction = false;
		// 		// 	}
		// 		// 	// console.log(self.progress);
		// 		//   }
		// 		// markers: true,
		// 	});

		// });


		// var inAction = false;
		var scrollClick = document.querySelector(".block-text-hero__arrows");
		var textHeroPanel = document.querySelector(".block-text-hero");

		function scrollNextSlide(currentPanel) {
			var nextPanel = currentPanel.nextElementSibling;
			console.log(nextPanel);
			ScrollTrigger.refresh();
			gsap.to(window, {duration: 0.8, scrollTo: {y: nextPanel }});
		}

		if (scrollClick !== null) {
			scrollClick.addEventListener("click", function () {
				scrollNextSlide(textHeroPanel);
			});
		}

		var skipAnimations = block.querySelectorAll(".block-student-animation__skip");
		var studentAnimationPanel = document.querySelector(".block-student-animation");



		if (skipAnimations !== null) {

			skipAnimations.forEach((faux, i) => {
				skipAnimations[i].addEventListener("click", function () {

					fauxSections.forEach((faux, i) => {
						ScrollTrigger.getById("student-" + i).disable();
					});

					scrollNextSlide(studentAnimationPanel);

				});
			});
		}


		// textAnimate.to(".slide-animation__pre-title", {
		// 	x: 0,
		// 	delay: 1,
		// 	opacity: 1,
		// 	duration: 0.5,
		// }).to(".slide-animation__title", {
		// 	x: 70,
		// 	delay: 1,
		// 	opacity: 1,
		// 	duration: 0.5,
		// });

		gsap.to('.block-student-animation__pre-title', {
			x: 0,
			duration: 1,
			autoAlpha: 1,
			scrollTrigger: {
			trigger: '.block-student-animation',
			start: 'top 10%',
			// markers: true
			}
		});

		var studentName = document.querySelector(".block-student-animation__title");
		var studentNameConvert = "";

		if (studentName !== null) {

			var studentNameText = studentName.textContent.trim();
			studentNameText = studentNameText.split("");

			studentNameText.forEach(function(char){
				studentNameConvert += "<span>" + char + "</span>";
			});

			studentName.innerHTML = studentNameConvert;
		}

		var tl = gsap.timeline({
			scrollTrigger: {
				trigger: ".block-student-animation",
				start: 'top 10%',
				toggleActions: "restart none none none"
			}
		});

		tl.from(".block-student-animation__title span", { opacity: 0, y: 50, ease: "power2", delay: 0.3, stagger: 0.1 });

		// gsap.to('.slide-animation__title', {
		// 	x: 70,
		// 	delay: 0.2,
		// 	duration: 1,
		// 	autoAlpha: 1,
		// 	letterSpacing: "5px",
		// 	scrollTrigger: {
		// 	  trigger: '.slide-animation',
		// 	  start: 'top 10%',
		// 	  // markers: true
		// 	}
		// });

		gsap.to('.block-student-animation__sub-title', {
			y: 0,
			delay: 0.8,
			duration: 0.5,
			autoAlpha: 1,
			scrollTrigger: {
			trigger: '.block-student-animation',
			start: 'top 10%',
			// markers: true
			}
		});


		// ScrollTrigger.create({
		// 	trigger: '.scroll-animation',
		// 	start: "top top",
		// 	end: "bottom top",
		// 	animation: textAnimate,
		// 	scrub: true,
		// 	// markers: true,
		// 	// onUpdate: self => {
		// 	// 	if(self.progress > 0 && self.progress < 1) {
		// 	// 	  inAction = true;
		// 	// 	} else {
		// 	// 	  inAction = false;
		// 	// 	}
		// 	// 	// console.log(self.progress);
		// 	//   }
		// 	// markers: true,
		// });

		// function applyClass() {
		// 	// alert("applied");
		// 	fauxSections.forEach((faux, i) => {
		// 		ScrollTrigger.getById("student-" + i).enable();
		// 	});
		// }

		// ScrollTrigger.create({
		// 	trigger: "body",
		// 	start: "top top",
		// 	// end: "bottom 90%",
		// 	// scrub: true,
		// 	onEnter: () => applyClass(),
		// 	// markers: true,
		// 	// onUpdate: self => {
		// 	// 	if(self.progress > 0 && self.progress < 1) {
		// 	// 	  inAction = true;
		// 	// 	} else {
		// 	// 	  inAction = false;
		// 	// 	}
		// 	// 	// console.log(self.progress);
		// 	//   }
		// 	// markers: true,
		// });

		var studentAnimationCarousel = new Swiper(".block-student-animation__carousel", {
			preloadImages: false,
			lazy: true,
			speed: 1000,
			loop: false,
			direction: "vertical",
			effect: "fade",
			allowTouchMove: false,
			autoplay: {
				delay: 3000,
			},
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
			// mousewheel: {
			// 	releaseOnEdges: true,
			// },

		});
		studentAnimationCarousel.autoplay.stop();

		ScrollTrigger.create({
			trigger: block,
			start: "top 50%",
			onEnter: () => studentAnimationCarousel.autoplay.start(),
		});

		studentAnimationCarousel.on('activeIndexChange', function() {
			let activeSlide = this.activeIndex;
			let activeMessage = this.slides[activeSlide].getAttribute("data-message");

			let messageContainer = document.querySelector(".block-student-animation__sub-title");
			let messageContainerSpan = messageContainer.querySelector("span");

			// let mobileMessageContainer = document.querySelector(".block-student-animation__mobile-sub-title");
			// let mobileMessageContainerSpan = mobileMessageContainer.querySelector("span");

			gsap.to(messageContainer, {width:"0px", duration: 1});
			gsap.to(messageContainerSpan, {autoAlpha:"0", duration: 0.5});

			// gsap.to(mobileMessageContainer, {width:"0px", duration: 1});
			// gsap.to(mobileMessageContainerSpan, {autoAlpha:"0", duration: 0.5});

			setTimeout(function(){
				messageContainerSpan.textContent = activeMessage;
				// mobileMessageContainerSpan.textContent = activeMessage;
			}, 300);

			gsap.to(messageContainer, {width:"auto", duration: 1, delay: 0.5});
			gsap.to(messageContainerSpan, {autoAlpha:"1", duration: 0.5, delay: 0.5});

			// gsap.to(mobileMessageContainer, {width:"auto", duration: 1, delay: 0.5});
			// gsap.to(mobileMessageContainerSpan, {autoAlpha:"1", duration: 0.5, delay: 0.5});

		});



		if (document.body.classList.contains('home')) {
			var logoAnim = gsap.timeline({
				scrollTrigger: {
					trigger: ".block-text-hero",
					start: 'bottom 50%',
					toggleActions: "play none none none"
				}
			});

			logoAnim.to(".site-header__logo", { opacity: 1, ease: "power2" });
		}


	}
}

export default StudentAnimation;
